import React from 'react';
import {observer} from 'mobx-react';

import {PartialGameViewModel} from "../../../../domain/partial-game/models/partial-game-view-model";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";

export class GameBadgeTooltipContentProps extends BaseProps {
  game: PartialGameViewModel;
  isEnded: Boolean;
}

export const GameBadgeTooltipContent = observer((props: GameBadgeTooltipContentProps) => {
  return (
    <div className={'game-badge-tooltip-content-container'}>
      <div className={['game-badge-tooltip-content-competitor', props.game.homeCompetitor.isWinner ? 'bold' : ''].join(' ')}>
        <div>{props.game.homeCompetitor.name} </div>
        {
          props.isEnded ? <div>{props.game.homeCompetitor.score} - </div> : ' - '
        }
      </div>
      <div className={['game-badge-tooltip-content-competitor', props.game.awayCompetitor.isWinner ? 'bold' : ''].join(' ')}>
        {
          props.isEnded ? <div>{props.game.awayCompetitor.score} </div> : null
        }
        <div>{props.game.awayCompetitor.name} </div>
      </div>
      {props.game.date}
    </div>
  )
});